<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-05 09:39:35
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-08 11:38:56
 * @FilePath: \member_ship\src\views\changeData.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="changeDataBody">
    <div class="headerBox">发布供需</div>
    <div class="mymainBox">
      <!-- <van-tabs v-model="active">
        <van-tab title="需求">
          <div class="listBox">
            <div class="listBoxItem" @click="gotodeltil(item)" v-for="item in arr1">
              <div class="listuserInfoBox">
                <div class="leftBox">
                  <p>{{item.Username}}</p>
                  <p style=" font-size: 12px;color:#a3a3a3">{{item.Hangye}}</p>
                </div>
                <div>
                  <van-tag type="primary">未完成</van-tag>
                </div>
              </div>
              <div class="maintextBox">
                <div>{{item.Title}}</div>
                <div>
                {{item.Content}}
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="招标">
             <div class="listBoxItem" @click="gotodeltil(item)" v-for="item in arr2">
              <div class="listuserInfoBox">
                <div class="leftBox">
                  <p>{{item.Username}}</p>
                  <p style=" font-size: 12px;color:#a3a3a3">{{item.Hangye}}</p>
                </div>
                <div>
                  <van-tag type="primary">未完成</van-tag>
                </div>
              </div>
              <div class="maintextBox">
                <div>{{item.Title}}</div>
                <div>
                {{item.Content}}
                </div>
              </div>
            </div>
        </van-tab>
        <van-tab title="招聘"> <div class="listBoxItem" @click="gotodeltil(item)" v-for="item in arr3">
              <div class="listuserInfoBox">
                <div class="leftBox">
                  <p>{{item.Username}}</p>
                  <p style=" font-size: 12px;color:#a3a3a3">{{item.Hangye}}</p>
                </div>
                <div>
                  <van-tag type="primary">未完成</van-tag>
                </div>
              </div>
              <div class="maintextBox">
                <div>{{item.Title}}</div>
                <div>
                {{item.Content}}
                </div>
              </div>
            </div></van-tab>
        <van-tab title="公告">
             <div class="listBoxItem" @click="gotodeltil(item)" v-for="item in arr4">
              <div class="listuserInfoBox">
                <div class="leftBox">
                  <p>{{item.Username}}</p>
                  <p style=" font-size: 12px;color:#a3a3a3">{{item.Hangye}}</p>
                </div>
                <div>
                  <van-tag type="primary">未完成</van-tag>
                </div>
              </div>
              <div class="maintextBox">
                <div>{{item.Title}}</div>
                <div>
                {{item.Content}}
                </div>
              </div>
            </div>
        </van-tab>
      </van-tabs> -->
       <div class="listBoxItem" @click="gotodeltil(item)" v-for="item in arrList">
              <div class="listuserInfoBox">
                <div class="leftBox">
                  <div class="leftBoxImgBox">
                    <img src="../assets/1668419337598639.jpg" style="width:100%;height:100%" alt="">
                  </div>
                   <div class="leftBoxImgBox2">
                      <p>{{item.Username}}</p>
                  <p style=" font-size: 12px;color:#a3a3a3;margin-top: 5px">{{getTime(item.CreateTime)}}</p>
                  </div>
                
                </div>
                <div>
                  <van-tag type="primary">{{item.Type}}</van-tag>
                </div>
              </div>
              <div class="maintextBox">
                <div class="mainTitle">{{item.Title}}</div>
                <div>
                {{item.Content}}
                </div>
              </div>
            </div>
      <div class="addNEwBtn" @click="addNewData">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      active: "最新发布",
      arrList: [],
      arr1: [],
      arr2: [],
      arr3: [],
      arr4: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getTime(time){
        return moment(Number(time)).format("YYYY-MM-DD HH:mm:ss")
    },
    addNewData() {
      this.$router.push("./addswap");
    },
    gotodeltil(data) {
      this.$router.push({
        path:"details",
        query:data
      });
    },
    getData() {
      this.$axios({
        method: "post",
        url: `https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getSanMingDemandData&uuid=6ffd1a30-44f8-4298-a84e-a184sta2415etyp` // 接口地址
      }).then(res => {
        console.log(res.data.dataList);
        this.arrList = res.data.dataList;
        this.arr1 = res.data.dataList.filter(function(el) {
          return (el.Type == "需求");
        });
        this.arr2 = res.data.dataList.filter(function(el) {
          return (el.Type == "招标");
        });
        this.arr3 = res.data.dataList.filter(function(el) {
          return (el.Type == "招聘");
        });
        this.arr4 = res.data.dataList.filter(function(el) {
          return (el.Type == "公告");
        });
      });
    }
  }
};
</script>

<style scoped>
.changeDataBody {
  height: 100vh;
  width: 100vw;
}
.headerBox {
  height: 80px;
  text-align: center;
  line-height: 120px;
  /* line-height: 50px; */
  /* background-color: #06bbe2; */
  background-image: url("../assets/OIP-C.jpg");
  color:white
}
.mymainBox {
  height: calc(100vh - 50px);
  width: 100%;
  overflow: auto;
  /* background-color: aqua; */
}
.addNEwBtn {
  height: 50px;
  width: 50px;
  position: absolute;
  bottom: 50px;
  right: 50px;
  z-index: 999;
  border-radius: 50%;
  background-color: #239EF1;
  font-size: 25px;
  text-align: center;
  line-height: 50px;
  color: white;
}
.listBox {
  width: 100%;
}
.listBoxItem {
  height: auto;
  width: 100%;
  /* padding: 10px; */
  padding: 20px 20px 50px 20px;
  /* border-bottom: 1px solid #a3a3a3; */

  /* background-color: #06BBE2; */
}
.listuserInfoBox {
  width: 100%;
  height: 30px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.leftBox {
  width: 50%;
  height: 50px;
  display: flex;
  align-items: center;
  /* background-color: aqua; */
}
.maintextBox {
  /* height: 100px; */
  width: 100%;
  margin-top: 15px;
}
.leftBoxImgBox{
  height: 40px;
  width: 40px;
  background-color: #06bbe2;
  border-radius: 50%;
  overflow: hidden;
}
.leftBoxImgBox2{
  margin-left: 15px;
}
.mainTitle{
  text-align: center;
  font-size: 12px;
  margin-bottom: 15px;
}

</style>